var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task_popover" },
    [
      _c(
        "el-popover",
        {
          ref: "taskPop",
          attrs: {
            placement: "right",
            width: "280",
            "visible-arrow": false,
            "popper-class": "popover_card",
            trigger: "click"
          }
        },
        [
          _c("TaskDefaultList", {
            attrs: { taskList: _vm.taskList, invoke: _vm.invoke }
          }),
          _vm._v(" "),
          _vm.taskList != undefined
            ? _c(
                "div",
                {
                  staticClass: "task_list",
                  attrs: { slot: "reference" },
                  slot: "reference"
                },
                [
                  _vm._l(_vm.taskList, function(itemTask, indexTask) {
                    return _c(
                      "div",
                      {
                        staticClass: "task_list_item",
                        class: {
                          gray_style:
                            new Date(itemTask.endTimeLong) < new Date(),
                          hidden: indexTask > 2
                        },
                        attrs: {
                          title:
                            itemTask.intvStartHourAndMinute +
                            " " +
                            itemTask.intvTitle
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(itemTask.intvStartHourAndMinute) +
                            " " +
                            _vm._s(itemTask.intvTitle) +
                            "\n      "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.taskList.length > 3
                    ? _c("div", { staticClass: "more_ellipsis" }, [
                        _vm._v("...")
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }